import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Message,
  Segment,
  Table,
} from 'semantic-ui-react';

export class Detail extends Component {
  state = {
    reassigned: false,
    leadClosed: false,
    error: null,
    dealerStatus: null,
    id: null,
    contractId: null,
    loading: true,
    note: '',
    renterData: {
      city: '',
      email: '',
      id: null,
      name: '',
      phone: '',
      state: '',
    },
    reqResponse: null,
    salesperson: null,
    salespersonData: {
      id:'',
      name: '',
    },
    salespersonStatus: null,
    salespeople: [],
    status: 0,
    systemData: {
      fuel: '',
      tonnage: '',
      variety: '',
    }
  }

  componentDidMount = () => {
    this.fetchData();
    this.fetchSalespeople();
  }

  fetchData = () => {
    const { id } = this.props;

    axios.get(`/leads/${id}/`)
      .then(({ data }) => {
        const newRenterData = {...this.state.renterData};

        this.setState({
          dealerStatus: data.dealer_status > -1 ? data.dealer_status : null,
          id,
          contractId: data.contract_id ? data.contract_id : null,
          renterData: {
            city: data.renter_city ? data.renter_city : 'n/a',
            email: data.renter_email ? data.renter_email : 'n/a',
            id: data.renter_id ? data.renter_id : null,
            name: data.renter_name ? data.renter_name : 'n/a',
            phone: data.renter_phone ? data.renter_phone : 'n/a',
            state: data.renter_state ? data.renter_state : 'n/a',
            zip: data.renter_zip ? data.renter_zip : 'n/a',
          },
          salesperson: data.salesperson ? data.salesperson.id : null,
          salespersonData: {
            id: data.salesperson ? data.salesperson.id : '',
            name: data.salesperson ? `${data.salesperson.first_name} ${data.salesperson.last_name}` : '',
          },
          salespersonStatus: data.salesperson_status > -1 ? data.salesperson_status : null,
          status: data.status,
          systemData: {
            fuel: data.fuel_formatted ? data.fuel_formatted : 'n/a',
            tonnage: data.tonnage_formatted ? data.tonnage_formatted : 'n/a',
            variety: data.variety_formatted ? data.variety_formatted : 'n/a',
          },
        });

        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          error: {
            message: err.response.data.ui_message,
          },
          loading: false,
        });
      })
  }

  fetchSalespeople = () => {
    axios.get('/salespeople/')
      .then(({ data }) => {
        let salespeople = data.map(s => ({ key: s.id, value: s.id, text: `${s.first_name} ${s.last_name}` }))

        this.setState({
          loading: false,
          salespeople,
        });
      })
      .catch((err) => {
        this.setState({
          error: {
            message: err.response.data.ui_message,
          },
          loading: false,
        });
      })
  }

  onAssignClick = (e) => {
    e.preventDefault();

    this.setState({
      loading: true,
    });

    // '/api/leads/:lead_id/assign-salesperson/:salesperson_id/?'
    axios.post(`/leads/${this.state.id}/assign-salesperson/${this.state.salesperson}/`)
      .then(() => {
        this.setState({
          reassigned: true,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          reqResponse: {
            header: 'There was a problem...',
            message: err.response.data.ui_message,
            success: false,
          }
        });

        setTimeout(() => {
          this.setState({
            reqResponse: null,
          });
        }, 5000);
      })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onCloseLeadClick = (e) => {
    e.preventDefault();

    this.setState({
      loading: true,
    });

    const postData = {
      lead_id: this.state.id,
      note: this.state.note,
    };

    axios.post(`/leads/${this.props.id}/dismiss-lead/`, postData)
      .then(() => {
        this.setState({
          leadClosed: true,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          reqResponse: {
            header: 'There was a problem...',
            message: err.response.data.ui_message,
            success: false,
          }
        });

        setTimeout(() => {
          this.setState({
            reqResponse: null,
          });
        }, 5000);
      })
  }

  onStartContract = (e) => {
    const { id } = this.props;

    this.setState({ loading: true });

    e.preventDefault();

    axios.post('/add-contract-shell/', { lead_id:  id })
      .then(({ data }) => this.addRenterToContract(data.id))
      .catch((err) => {
        this.setState({ loading: false, error: { message: err.response.data.ui_message } });
      })
  }

  addRenterToContract(contractId) {
    axios.put(`/contracts/${contractId}/add-renter/`, {
      contract_id: contractId,
      id: this.state.renterData.id,
    })
      .then(() => {
        window.location = `/dealer/contracts/${contractId}`;
      })
      .catch((err) => {
        this.setState({ loading: false, error: { message: err.response.data.ui_message } });
      })
  }

  render() {
    const {
      renterData,
      reqResponse,
      systemData,
      status,
    } = this.state;

    let statusFormatted = 'Assigned';
    let salespersonName = '';

    if (this.state.salespeople.length && this.state.salesperson) {
      salespersonName = this.state.salespeople.filter(s => s.value === this.state.salesperson)[0].text;
    }

    if (this.state.error) {
      return (
        <Segment padded>
          <h1>Lead Detail</h1>
          <Message
            negative
            icon="exclamation"
            header="There was a problem..."
            content={this.state.error.message}
          />
        </Segment>
      );
    }

    if (this.state.leadClosed || this.state.reassigned) {
      return (
        <Segment padded>
          <h1>
            {
              this.state.leadClosed
                ? 'This lead has been closed'
                : `This lead has been assigned to ${salespersonName}`
            }
          </h1>
          <Button
            as={Link}
            primary
            to="/dealer/leads"
            icon="arrow left"
            content="Back to leads"
          />
        </Segment>
      );
    }

    let actionsDisabled = false;

    if (
      this.state.status === 3 ||
      this.state.dealerStatus === 2 ||
      this.state.dealerStatus === 3 ||
      this.state.dealerStatus === 4 ||
      this.state.salespersonStatus === 2 ||
      this.state.salespersonStatus === 3 ||
      this.state.salespersonStatus === 4
    ) {
      actionsDisabled = true;
    }

    return (
      <Segment padded loading={this.state.loading}>
        <Header
          as="h1"
          content="Lead Detail"
          subheader={`${statusFormatted} Lead`}
        />
        <h2>Renter Info</h2>
        <Table size="large" color="green" striped celled columns={2}>
          <Table.Body>
            <Table.Row>
              <Table.Cell content="Name" />
              <Table.Cell content={renterData.name} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Email" />
              <Table.Cell content={renterData.email} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Phone" />
              <Table.Cell content={renterData.phone} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Location" />
              <Table.Cell content={`${renterData.city}, ${renterData.state}`} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Zip" />
              <Table.Cell content={renterData.zip} />
            </Table.Row>
          </Table.Body>
        </Table>
        <h2>System Info</h2>
        <Table size="large" color="green" striped celled columns={2}>
          <Table.Body>
            <Table.Row>
              <Table.Cell content="Tonnage" />
              <Table.Cell content={`${systemData.tonnage}`} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Fuel" />
              <Table.Cell content={systemData.fuel} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Variety" />
              <Table.Cell content={systemData.variety} />
            </Table.Row>
          </Table.Body>
        </Table>
        {
          actionsDisabled &&
          this.state.salesperson
            ? (
                <div style={{ marginTop: '30px' }}>
                  <h2>Salesperson: {salespersonName}</h2>
                </div>
              )
            : null
        }
        {
          this.state.salespersonStatus === null &&
          !actionsDisabled
            ? (
                <div style={{ marginTop: '40px' }}>
                  <Button
                    content="Start Contract With This Lead"
                    positive
                    icon="arrow right"
                    labelPosition="right"
                    disabled={reqResponse ? true : false}
                    onClick={this.onStartContract}
                  />
                </div>
              )
            : null
        }
        {
          !actionsDisabled
            ? <Divider />
            : null
        }
        {
          this.state.contractId &&
            <div>
              <h2>A contract has been started with this lead</h2>
              <Button
                as={Link}
                to={`/dealer/contracts/${this.state.contractId}`}
                content="View Contract"
                icon="eye"
                basic
              />
            </div>
        }
        {
          !actionsDisabled
            ? (
                <div style={{ padding: '10px 0 20px 0' }}>
                  <Header
                    as="h3"
                    content="Assign This Lead to a Salesperson"
                    subheader={
                      this.state.salespersonData.name
                        ? `Currently assigned to ${this.state.salespersonData.name}`
                        : ''
                    }
                  />
                  <Form>
                    <Form.Select
                      label="Salesperson"
                      placeholder="Choose a salesperson..."
                      options={this.state.salespeople}
                      value={this.state.salesperson}
                      name="salesperson"
                      onChange={(e, t) => this.onChange({ target: { name: t.name, value: t.value }})}
                      required
                    />
                    <Button
                      content="Assign"
                      positive
                      disabled={!this.state.salesperson}
                      onClick={this.onAssignClick}
                    />
                  </Form>
                </div>
              )
            : null
        }
        {
          this.state.salespersonStatus === null &&
          !actionsDisabled
            ? (
                <div>
                  <Divider />
                  <div style={{ padding: '20px 0' }}>
                    <h3>Close This Lead</h3>
                    <p>
                      By clicking on "Close This Lead", you are certifying that you
                      contacted this lead and attempted a sale. Since this lead failed to
                      convert, explain why below.
                    </p>
                    <Form>
                      <Form.TextArea
                        label="Note"
                        name="note"
                        onChange={this.onChange}
                        required
                        value={this.state.note}
                      />
                      <Button
                        content="Close This Lead"
                        negative
                        disabled={!this.state.note || reqResponse ? true : false}
                        onClick={this.onCloseLeadClick}
                      />
                    </Form>
                  </div>
                </div>
              )
            : null
        }
        {
          reqResponse
            ? (
                <Message
                  icon="exclamation"
                  negative
                  header={reqResponse.header}
                  content={reqResponse.message}
                />
              )
            : null
        }
      </Segment>
    );
  }
}
